import { Dispatch, SetStateAction } from "react";
import {
  BlueBirdTheme, Button, Checkbox, Typography,
} from "@kitbird/core";
import { toRupiah, toStringDate } from "../../../utils/common";
import { ColumnI } from "../../../components/Table/TableProps";
import { ReactComponent as ShowIcon } from "../../../assets/icons/show_icon.svg";
import { CommonTrxTypes } from "../../../enums/common";
import { IGetTrxTypeResponse } from "../../../services/trxTypeService/types";
import { WithdrawalModalType } from "./hooks/Provider";

const {
  gray, primary,
} = BlueBirdTheme.colors;

const columns = (
  rowsLength: number,
  selectedRows: any[],
  handleCheckRow: (item: any) => void,
  handleCheckAllRows: () => void,
  setModalConfig: Dispatch<SetStateAction<{ id?: string, type: WithdrawalModalType } | undefined>>,
  dataTrxType?: IGetTrxTypeResponse,
): ColumnI[] => [{
  title: <Checkbox
    checked={!!rowsLength && selectedRows.length === rowsLength}
    onChange={() => handleCheckAllRows()}
  />,
  dataIndex: "trx_id",
  key: "checkbox",
  width: "65px",
  sticky: "left",
  render: (item, row) => <Checkbox
    checked={selectedRows.findIndex((selectedRow) => selectedRow.trx_id === item) !== -1}
  />,
},
{
  title: "No. pengajuan bon",
  dataIndex: "trx_id",
  key: "trx_id",
  sort: true,
  width: "160px",
},
{
  title: "Tanggal pengajuan",
  dataIndex: "trx_date",
  key: "trx_date",
  sort: true,
  width: "160px",
  render: (item) => toStringDate(item),
},
{
  title: "Pemohon & NIP",
  dataIndex: "employee_name",
  key: "employee_name",
  width: "140px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {row.employee_id}
      </Typography>
    </>
  ),
},
{
  title: "Total bon & tipe transaksi",
  dataIndex: "amount",
  key: "amount",
  sort: true,
  width: "200px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {toRupiah(row.amount)}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {dataTrxType?.lstmsttrxtype?.find((type) => type.trx_type === row.trx_type)?.description}
      </Typography>
    </>
  ),
},
{
  title: "Deskripsi",
  dataIndex: "trx_text",
  key: "trx_text",
  sort: true,
  width: "225px",
},
{
  title: "Perusahaan & relasi",
  dataIndex: "company_code",
  key: "company_code",
  sort: true,
  width: "165px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item}
      </Typography>
      <br />
    </>
  ),
},
{
  title: "Akun GL",
  dataIndex: "trx_code",
  key: "trx_code",
  sort: true,
  width: "175px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item} • {CommonTrxTypes.find(
          (type) => type.value === row.sap_shkzg,
        )?.label}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {row.trx_desc}
      </Typography>
    </>
  ),
},
{
  title: "Action",
  dataIndex: "trx_id",
  key: "action",
  width: "60px",
  sticky: "right",
  render: (item, row) => (<div style={{ display: "flex", gap: 8 }}>
    <Button
      size="sm"
      backgroundColor={primary[300]}
      style={{ padding: 8 }}
      onClick={(e) => {
        e.stopPropagation();
        setModalConfig({ id: item as string, type: "DETAIL" });
      }}
    >
      <ShowIcon />
    </Button>
  </div>),
}];

export default columns;
